import { useEffect, useRef } from 'react';

const SessionTimerContent = ({ timer, logout }) => {
  const timeRef = useRef(null);
  useEffect(() => {
    let time = Math.trunc(timer / 1000).toFixed(0);
    timeRef.current.textContent = time;
    let timerInterval = setInterval(() => {
      time--;
      if (!time) {
        logout();
        clearInterval(timerInterval);
      }
      timeRef.current.textContent = time;
    }, 1000);

    return () => {
      clearInterval(timerInterval);
    };
  }, []);

  return (
    <p>
      ¿Desea renovar la sesión? Expirará en <b ref={timeRef}> </b>
    </p>
  );
};

export default SessionTimerContent;
